"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applicationUserListApi = applicationUserListApi;
exports.brandUserListApi = brandUserListApi;
exports.contentUserListApi = contentUserListApi;
exports.dataUserListApi = dataUserListApi;
exports.reportUserListApi = reportUserListApi;
exports.userActivateUserApi = userActivateUserApi;
exports.userActivitiesApi = userActivitiesApi;
exports.userAddApi = userAddApi;
exports.userAdminApi = userAdminApi;
exports.userAuthorizeDeviceApi = userAuthorizeDeviceApi;
exports.userBulkActivateApi = userBulkActivateApi;
exports.userBulkDeactivateApi = userBulkDeactivateApi;
exports.userBulkHardDeleteApi = userBulkHardDeleteApi;
exports.userBulkSoftDeleteApi = userBulkSoftDeleteApi;
exports.userBulkSoftDeleteRestoreApi = userBulkSoftDeleteRestoreApi;
exports.userDeactivateUserApi = userDeactivateUserApi;
exports.userDeletedByListApi = userDeletedByListApi;
exports.userDetailsApi = userDetailsApi;
exports.userFetchApi = userFetchApi;
exports.userHardDeleteApi = userHardDeleteApi;
exports.userListApi = userListApi;
exports.userResetPasswordCommonApi = userResetPasswordCommonApi;
exports.userSendEmailApi = userSendEmailApi;
exports.userSoftDeleteApi = userSoftDeleteApi;
exports.userSoftDeletedListApi = userSoftDeletedListApi;
exports.userSoftRestoreApi = userSoftRestoreApi;
exports.userTenantPermissionApi = userTenantPermissionApi;
exports.userUniqueEmailApi = userUniqueEmailApi;
exports.userUpdateApi = userUpdateApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
var _genericFunction = require("../../../../helpers/genericFunction");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * Send mail
 * @param payload
 * @returns api response
 * @description this function used send mail for new account.
 */
function userSendEmailApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.UserService.user.mail), params);
}

/** add user
 * @param payload
 * @returns api response
 * @description this function used to add user.
 */
function userAddApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.UserService.user.user), params);
}

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get user.
 */
function userFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.user), params);
}

/**
 * details
 * @param payload
 * @returns api response
 * @description this function used to get details.
 */
function userDetailsApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.organization), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function userListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.list), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function userDeletedByListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.deletedByList), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function brandUserListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.list), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function contentUserListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.list), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function applicationUserListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.list), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function dataUserListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.list), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function reportUserListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.list), params);
}

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used soft delete for user.
 */
function userSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.UserService.user.softDelete), params);
}

/**
 * hard delete
 * @param payload
 * @returns api response
 * @description this function used to hard delete user.
 */
function userHardDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.UserService.user.hardDelete), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update user.
 */
function userUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.user.user), params);
}

/**
 * soft restore
 * @param payload
 * @returns api response
 * @description this function used to soft restore user.
 */
function userSoftRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.user.restore), params);
}

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft deleted list.
 */
function userSoftDeletedListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.softDeletedList), params);
}

/**
 * unique email
 * @param payload
 * @returns api response
 * @description this function used to unique email.
 */
function userUniqueEmailApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.uniqueEmail), params);
}

/**
 * user bulk delete
 * @param payload
 * @returns api response
 * @description this function used to user bulk delete.
 */
function userBulkHardDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.user.bulkHardDelete), params);
}

/**
 * user bulk activate
 * @param payload
 * @returns api response
 * @description this function used to user bulk activate.
 */
function userBulkActivateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.user.bulkActivate), params);
}

/**
 * user bulk deactivate
 * @param payload
 * @returns api response
 * @description this function used to user bulk deactivate.
 */
function userBulkDeactivateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.user.bulkDeactivate), params);
}

/**
 * user activities
 * @param payload
 * @returns api response
 * @description this function used to log user activities.
 */
function userActivitiesApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.UserService.user.activities), params);
}

/** Validate token
 * @param payload
 * @returns api response
 * @description this function used to check validated token.
 */
function userAuthorizeDeviceApi(params) {
  var _window, _window$location, _window$location$host, _window2, _window2$location, _window2$location$hos, _baseUrl_, _window3, _window3$location, _window3$location$hos;
  var baseUrl_ = _app.default.baseUrl;
  if (!((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && (_window$location$host = _window$location.host) !== null && _window$location$host !== void 0 && _window$location$host.startsWith("platform") || (_window2 = window) !== null && _window2 !== void 0 && (_window2$location = _window2.location) !== null && _window2$location !== void 0 && (_window2$location$hos = _window2$location.host) !== null && _window2$location$hos !== void 0 && _window2$location$hos.startsWith("canada")) && (_baseUrl_ = baseUrl_) !== null && _baseUrl_ !== void 0 && _baseUrl_.includes("platform.api") && !((_window3 = window) !== null && _window3 !== void 0 && (_window3$location = _window3.location) !== null && _window3$location !== void 0 && (_window3$location$hos = _window3$location.host) !== null && _window3$location$hos !== void 0 && _window3$location$hos.includes("localhost"))) {
    var splitUrl = window.location.host.split(".");
    var obj = _genericFunction.mappingUrlProduction === null || _genericFunction.mappingUrlProduction === void 0 ? void 0 : _genericFunction.mappingUrlProduction.find(function (f) {
      return f.key === window.location.host;
    });
    if (obj !== null && obj !== void 0 && obj.value) {
      baseUrl_ = baseUrl_.replace("platform.api", (obj === null || obj === void 0 ? void 0 : obj.value) + ".api");
    } else {
      baseUrl_ = baseUrl_.replace("platform.api", splitUrl[0] + ".api");
    }
  }
  return api.update("".concat(baseUrl_ + _dashboard.UserService.user.authorizeDevice), params);
}

/**
 * Activate user
 * @param payload
 * @returns api response
 * @description this function used to activate user.
 */
function userActivateUserApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.user.userActivateUser), params);
}

/**
 * Deactivate user
 * @param payload
 * @returns api response
 * @description this function used to deactivate user.
 */
function userDeactivateUserApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.user.userDeactivateUser), params);
}

/**
 * Reset password common
 * @param payload
 * @returns api response
 * @description this function used to reset passworld its credencials.
 */
function userResetPasswordCommonApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.user.resetPasswordCommon), params);
}

/**
 * get permission data
 * @param payload
 * @returns api response
 * @description this function used to get permission data.
 */
function userTenantPermissionApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.tenantPermission), params);
}

/**
 * get user admin details
 * @param payload
 * @returns api response
 * @description this function used to get user admin details.
 */
function userAdminApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.user.userAdmin));
}

/**
 * user bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to user bulk soft delete.
 */
function userBulkSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.user.bulkSoftDelete), params);
}

/**
 * user bulk soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to user bulk soft delete restore.
 */
function userBulkSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.user.bulkSoftDeleteRestore), params);
}